import {
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiNodedotjs,
  SiLaravel,
  SiTailwindcss,
  SiBootstrap,
  SiMysql,
  SiPostgresql,
  SiGit,
  SiFigma,
  SiLinux,
  SiNginx
} from "react-icons/si";

export const tools = [
  { name: "JavaScript", IconComponent: SiJavascript, color: "#F7DF1E" },
  { name: "TypeScript", IconComponent: SiTypescript, color: "#3178C6" },
  { name: "React.js", IconComponent: SiReact, color: "#61DAFB" },
  { name: "Next.js", IconComponent: SiNextdotjs, color: "#000000" },
  { name: "Node.js", IconComponent: SiNodedotjs, color: "#68A063" },
  { name: "Laravel", IconComponent: SiLaravel, color: "#FF2D20" },
  { name: "Tailwind CSS", IconComponent: SiTailwindcss, color: "#38BDF8" },
  { name: "Bootstrap", IconComponent: SiBootstrap, color: "#7952B3" },
  { name: "MySQL", IconComponent: SiMysql, color: "#4479A1" },
  { name: "PostgreSQL", IconComponent: SiPostgresql, color: "#336791" },
  { name: "Linux", IconComponent: SiLinux, color: "#FCC624" },
  { name: "Nginx", IconComponent: SiNginx, color: "#009639" },
  { name: "Git", IconComponent: SiGit, color: "#F1502F" },
  { name: "Figma", IconComponent: SiFigma, color: "#F24E1E" },
];